import { setSearchTerm } from "../stockFeesDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useStockFeeSearch = () =>
  useSearch((s) => s.data.clearing.stockfees.searchTerm, setSearchTerm);
